import { useEffect, useState } from 'react';

/**
 * Aktuální čas, který se obnovuje jednou za minutu. Relativní časy („naposledy před 12 min“) se tak
 * posouvají i ve chvíli, kdy se data ze serveru nemění a React Query nic nepřekreslí.
 */
export const useTed = (intervalMs: number = 60 * 1000): number => {
    const [ted, setTed] = useState(() => Date.now());
    useEffect(() => {
        const t = window.setInterval(() => setTed(Date.now()), intervalMs);
        return () => window.clearInterval(t);
    }, [intervalMs]);
    return ted;
};
